import { render, staticRenderFns } from "./ShowBigImage.vue?vue&type=template&id=24e5fc81&scoped=true"
import script from "./ShowBigImage.vue?vue&type=script&lang=js"
export * from "./ShowBigImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e5fc81",
  null
  
)

export default component.exports